import React from 'react'

const StatisticsCard = ({
  stats,
  columns = 'xl:grid-cols-4',
  text = 'text-[9px]',
}) => {
  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 ${columns} gap-4 mb-8 animate-in slide-in-from-bottom duration-700 delay-200`}
    >
      {stats.map((stat) => (
        <div
          key={stat.label}
          className='bg-white rounded-lg shadow-lg p-4 hover:shadow-xl  transition-all duration-300 hover:-translate-y-1 cursor-pointer group'
        >
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='flex justify-between items-center gap-2'>
                <div
                  className={`flex items-center justify-center w-12 h-12 ${stat.textColor} ${stat.bgColor} text-2xl font-bold rounded-lg group-hover:scale-110 transition-transform duration-200`}
                >
                  {stat.value}
                </div>
                <div>
                  <p className='text-sm font-medium text-gray-600'>
                    {stat.label}
                  </p>
                  <p className={`${text} line-clamp-2  text-gray-500`}>
                    {stat.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default StatisticsCard
